var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-indicator is-flex"},_vm._l((_vm.steps),function(item,index){return _c('div',{key:index,class:item ? 'is-active has-background-blue' : 'not-active'})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }